<template>
  <Toast/>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="page-header centrer">
            <div class="row">
              <div class="col-1"/>
              <div class="col-10">
                <h1>Audits des modifications Intervenant</h1>
              </div>
              <div class="col-1 text-right no-print">
                  <Button class="no-print" label="Fermer" v-on:click="fermer"/>
              </div>
            </div>
            <h3 class="confidentiel">Confidentiel</h3>
            <h3 v-if="isDataLoaded">
<!--              Intervenant : {{ intervenant.prenom }} {{ intervenant.nom }} ({{ intervenant.numeroFiche }})<br />-->
<!--              Créé par : {{ intervenant.creerParEntite?.nomIntervenant?.trim() }}, {{ intervenant.creerParEntite?.prenomIntervenant?.trim() }}, {{ intervenant.creerParEntite?.nomGroupeSecurite?.trim() }} <br />-->
<!--              Le : {{ this.$commun.formatDateHeure(intervenant.creerLe) }}-->
            </h3>
            <div v-else>
              <Skeleton />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <table class="centrer">
            <thead>
              <tr>
                <td>
                  <!--place holder for the fixed-position header-->
                  <div class="page-header-space"></div>
                </td>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <!--*** CONTENT GOES HERE ***-->
                  <div>
                    <TableModifications @backendError="showError" @isDataLoaded="getIsDataLoaded"/>
                  </div>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td>
                  <!--place holder for the fixed-position footer-->
                  <div class="page-footer-space"></div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="page-footer centrer">
            <p>Généré le {{ getCurrentDateTime() }} par {{ currentUser }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableModifications from "../../../components/pilotage/intervenant/AuditModifications/TableModifications.vue";
import axios from 'axios';
import {mapGetters} from "vuex";

export default {
  name: "IntervenantAuditModifications",
  components: {
    TableModifications,
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Audit des modifications Intervenant");
  },
  data() {
    return {
      currentUser: "",
      isDataLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      intervenant: "pilotage/intervenant",
    }),
  },
  methods: {
    assignerInformationUtilisateur(res) {
      this.currentUser = res.data.codeProfilUtilisateur;
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    getCurrentDateTime() {
      return this.$commun.formatDateHeure(new Date());
    },
    getIsDataLoaded(value) {
      this.isDataLoaded = value;
    },
    showError(error) {
      this.$toast.add({
        severity: 'error',
        summary: 'Audits',
        detail: 'Erreur lors de la récupération des audits de l intervenant: ' + error,
        life: 5000
      })
    },
  },
};
</script>